import { create } from 'zustand';
import { createSelectors } from './utils';

export interface SnackbarOptions {
  autoHide?: number | null;
  severity?: 'success' | 'error' | 'info';
}

interface SnackbarState {
  snackbar: {
    message: string;
    open: boolean;
    options: SnackbarOptions;
  };
  showSnackbar: (message: string, options?: SnackbarOptions) => void;
  closeSnackbar: () => void;
}

const defaultOptions: SnackbarOptions = {
  severity: 'success',
  autoHide: 4000,
};

const useSnackbarStoreRaw = create<SnackbarState>((set) => ({
  snackbar: {
    message: '',
    open: false,
    options: defaultOptions,
  },
  showSnackbar: (message, options = {}) =>
    set({
      snackbar: {
        message,
        open: true,
        options: { ...defaultOptions, ...options },
      },
    }),
  closeSnackbar: () =>
    set((state) => ({
      snackbar: { ...state.snackbar, open: false },
    })),
}));

const useSnackbarStore = createSelectors(useSnackbarStoreRaw);

export default useSnackbarStore;
